import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';

interface ISideBarLinkProps {
    icon: any;
    text: string;
    href: string;
    liClass?: string;
    navClass?: string;
}

export default function SideBarLink(props: ISideBarLinkProps) {
    return (
        <li className={props.liClass}>
            <NavLink
                to={props.href}
                className={({ isActive }) =>
                    `${props.navClass || 'nav-link'} d-flex align-items-center ${isActive ? 'active' : 'link-dark'}`
                }
            >
                <FontAwesomeIcon icon={props.icon} className="sidebar-icon me-2" />
                <span>{props.text}</span>
            </NavLink>
        </li>
    );
}
